import angular from 'angular';

angular.module('portainer.agent', []);
